import(/* webpackMode: "eager" */ "/home/runner/work/pluswilla/pluswilla/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pluswilla/pluswilla/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/Blog/BlogSubbanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/Blog/TvsNagar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/components/layout/Header.tsx");
